var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle2, _g2, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHongKongMark6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.288 41.925 59.501 55.407l5.939 4.14-10.787 19.141 18.34-19.141-7.105-4.858z",
    fill: "#6a0307"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.356 42.596 60.582 55.407l5.426 4.046-9.743 17.034 15.729-16.764-6.825-4.942z",
    fill: "#a91e37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m74.335 27.548-13.93 13.305 5.389 2.331-6.825 10.787 15.365-11.505-7.011-2.331z",
    fill: "#108d50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m74.335 27.548-9.883 12.671 6.293 2.695-11.776 11.058 15.365-11.505-7.011-2.331z",
    fill: "#0a4e9b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.585 55.136h53.928v1.259H4.585z",
    fill: "#a91e37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.585 55.407h53.928v.718H4.585z",
    fill: "#6a0307"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.076 55.136h26.339v1.259H69.076z",
    fill: "#a91e37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6a0307"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.076 55.407h26.339v.718H69.076z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.626,
    cy: 23.865,
    r: 4.494
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.626,
    cy: 23.865,
    r: 4.13,
    fill: "#b21935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.77 13.432c0 1.66-1.352 3.012-3.012 3.012s-3.012-1.352-3.012-3.012 1.352-3.012 3.012-3.012 3.012 1.352 3.012 3.012z",
    fill: "#6a0307"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.425 13.432a2.676 2.676 0 0 1-2.676 2.676 2.67 2.67 0 1 1 0-5.352 2.67 2.67 0 0 1 2.676 2.676z",
    fill: "#b21935"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.088 10.523a3.49 3.49 0 0 1-3.496 3.487 3.496 3.496 0 0 1-3.496-3.487 3.496 3.496 0 0 1 3.496-3.496 3.49 3.49 0 0 1 3.496 3.496z",
    fill: "#0e6034"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.697 10.523a3.095 3.095 0 1 1-3.095-3.095 3.081 3.081 0 0 1 3.095 3.095z",
    fill: "#108d50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.295 21.254a2.685 2.685 0 0 1-2.676 2.676 2.685 2.685 0 0 1-2.676-2.676 2.685 2.685 0 0 1 2.676-2.676 2.685 2.685 0 0 1 2.676 2.676z",
    fill: "#283f6d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.987 21.254a2.374 2.374 0 0 1-4.746 0 2.378 2.378 0 0 1 2.378-2.378 2.373 2.373 0 0 1 2.368 2.378z",
    fill: "#0a4e9b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.097 31.902c0 1.305-1.054 2.359-2.359 2.359s-2.359-1.054-2.359-2.359 1.054-2.359 2.359-2.359a2.368 2.368 0 0 1 2.359 2.359z",
    fill: "#0e6034"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.836 31.902c0 1.156-.932 2.088-2.088 2.088s-2.088-.932-2.088-2.088.932-2.088 2.088-2.088a2.09 2.09 0 0 1 2.088 2.088z",
    fill: "#108d50"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.638 13.348c0 2.331-1.893 4.224-4.224 4.224s-4.224-1.893-4.224-4.224 1.893-4.224 4.224-4.224a4.214 4.214 0 0 1 4.224 4.224z",
    fill: "#283f6d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.414,
    cy: 13.348,
    r: 3.888,
    fill: "#0a4e9b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0e4a9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.827 36.237h19.831v2.452H4.827zm.242 15.999s1.259-2.219 2.76-6.293 1.678-5.576 1.678-5.576h2.452s-.485 2.517-1.501 5.93-2.881 6.48-2.881 6.48l-2.508-.541zm13.874-11.16 2.247-.699s1.016 2.517 1.977 5.93 1.855 5.51 1.855 5.51l-2.34.96-2.517-6.89c-.839-2.704-1.221-4.811-1.221-4.811zm28.428.317-5.156-6.527c-2.219-2.517-3.897-1.622-5.361-1.203l-2.592.82.401-.765-2.154-1.315s-1.557 3.114-2.937 5.063l-2.816 3.981 2.098 1.436 2.228-3.142v1.016h11.561v-1.79l2.368 3.916 2.359-1.492zm-15.748-2.48.802-1.268.354-.597c1.827-.681 5.38-1.949 6.433-1.949.709 0 2.126 1.902 3.384 3.823H31.623z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.506 50.083h-.55a33.16 33.16 0 0 0 .354-3.879c.075-2.564-1.212-2.918-2.378-2.965s-1.93-.131-5.566-.009l-5.687.252c-.065-.718-.793-.559-1.557-.597-.765-.028-.895.298-.895.298v9.585c0 .289.364.392.364.392h1.501c.513 0 .587-.625.587-.625v-.298h13.827v-2.154zm-13.808-4.578 4.168-.252c3.907-.317 5.93-.494 6.517-.093.438.308.364 3.394.298 4.914H31.688l.009-4.569zM61.03 34.559v-2.154s-1.352.494-4.988.755l-6.694.41v2.154l5.035-.27c3.776-.224 6.648-.895 6.648-.895zm-2.331 3.086c-.671 1.287-1.165 2.722-1.165 2.722l1.436 1.063 1.557-2.517 1.361-2.294-2.023-1.165-1.165 2.191zm-5.259 2.722-2.051-4.13-2.042.923 2.35 4.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.44 36.666 2.2 3.17 1.305-.699c-.224-.354-1.753-3.739-1.753-3.739s-.28.019-.858.643c-.569.615-.895.625-.895.625zm3.012 4.652c0-.28-.494-.513-1.1-.513s-1.1.233-1.1.513v1.091h-5.193v2.154h2.126l-.522 2.667c-.448 2.154-1.305 4.587-1.305 4.587l2.35.765 1.203-4.83c.261-1.249.401-2.415.476-3.179h.876v8.083c0 .28.494.513 1.1.513s1.1-.233 1.1-.513v-8.083h.811l.718 4.419c.401 2.34.988 3.599.988 3.599l1.781-1.417s-.149-1.361-.559-2.489c-.317-.867-.606-3.058-.765-4.102h1.604v-2.154h-4.587v-1.11z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m80.358 62.791.047-5.305 1.119.047-.047 5.259z",
    fill: "#b21935"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.43 57.579v5.165h-.979v-5.165h.979m.093-.093h-1.165v5.352h1.165v-5.352z",
    fill: "#6a0307"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.424 62.838v-5.352h1.203l1.427 3.795.289.793.317-.858 1.445-3.729h1.082v5.352h-.765v-4.485l-1.753 4.485h-.727L6.189 58.28v4.559h-.765zm14.191 0 2.098-5.352h.783l2.238 5.352h-.82l-.634-1.622h-2.284l-.597 1.622h-.783zm1.576-2.2h1.855l-.569-1.482-.392-1.11a7.036 7.036 0 0 1-.289 1.026l-.606 1.566zm12.037 2.2v-5.352h2.555c.513 0 .904.047 1.175.149a1.2 1.2 0 0 1 .643.513 1.454 1.454 0 0 1 .242.811c0 .382-.131.699-.401.96-.261.261-.671.429-1.231.494.205.093.466-.093.858.401.177.233.485 2.033.485 2.033h-.96l-.093-1.501c-.214-.718-1.436-.709-1.632-.709h-.886l.009 2.219h-.765zm.765-2.993h1.641c.354 0 .625-.037.82-.103s.345-.177.448-.317a.824.824 0 0 0 .149-.485c0-.252-.103-.466-.298-.625s-.513-.242-.942-.242h-1.827v1.771zm12.484 2.993v-5.352h.765v2.657l2.862-2.657h1.035l-2.424 2.172 2.527 3.189h-1.007l-2.051-2.713-.942.858v1.855h-.765z",
    fill: "#1f346c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m89.868 62.791 2.014-2.722-1.79-2.611 1.324.075 1.119 1.697 1.212-1.716 1.315.019-1.837 2.527 1.921 2.732H93.83l-1.24-1.827-1.361 1.846z",
    fill: "#b21935"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m94.884 57.579-1.697 2.452-.037.056.037.056 1.865 2.611h-1.175l-1.249-1.809-.075-.112-.075.112-1.259 1.809h-1.165l1.865-2.648.037-.056-.037-.056-1.688-2.415h1.137l1.128 1.678.075.112.075-.121 1.11-1.678h1.128m.177-.084h-1.352l-1.137 1.725-1.156-1.725h-1.361l1.79 2.564-1.967 2.797h1.399l1.287-1.855 1.277 1.855h1.408l-1.977-2.75 1.79-2.611z",
    fill: "#6a0307"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongKongMark6);
export default __webpack_public_path__ + "static/media/hong_kong_mark_6.4973dd462de9021fb41bef9560a02f9f.svg";
export { ForwardRef as ReactComponent };